"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var base_condition_1 = require("./base.condition");
var models_1 = require("../../models");
var ProactiveFormTagValidCondition = /** @class */ (function (_super) {
    __extends(ProactiveFormTagValidCondition, _super);
    function ProactiveFormTagValidCondition(optionService, formTagName, notificationService) {
        var _this = _super.call(this, "ProactiveFormTagValidCondition", notificationService) || this;
        _this.observable = new rxjs_1.Observable(function (observer) {
            if (!formTagName) {
                console.log("ProactiveFormTagValidCondition :: Passed as FormTag name was not defined in chat rule");
                observer.next(true);
                return;
            }
            optionService.getProactiveFormDetails("en", formTagName).subscribe(function (formData) {
                if (formData && formData.tag && formData.tag === formTagName) {
                    console.log("ProactiveFormTagValidCondition :: Passed as provided form tag " + formTagName + " is valid");
                    observer.next(true);
                    return;
                }
                _this.onConditionFail(models_1.ConditionFailReason.ConfigurationError, "ProactiveFormTagValidCondition :: Failed as provided form tag " + formTagName + " is invalid");
                observer.next(false);
            }, function (err) {
                _this.onConditionFail(models_1.ConditionFailReason.ServerError, "ProactiveFormTagValidCondition :: Failed to get form for the form tag " + formTagName + " due to error " + err);
                observer.next(false);
            });
        });
        return _this;
    }
    return ProactiveFormTagValidCondition;
}(base_condition_1.BaseCondition));
exports.ProactiveFormTagValidCondition = ProactiveFormTagValidCondition;
